import { Link } from 'react-router-dom';

export function Wordmark() {
  return (
    <Link to="/" className="font-extrabold tracking-tight text-[18px] leading-none select-none">
      <span className="text-[#111111] dark:text-white">stashstr</span>
      <span className="text-[#f97316]"> news.</span>
    </Link>
  );
}
